import React from 'react';
import { Container } from 'react-bootstrap';
import { useModal } from '../../hooks/useModal';

const CTASection: React.FC = () => {
  const { openUserTypeModal } = useModal();

  return (
    <Container fluid className="text-center">
      <div
        className="frame10"
        style={{ backgroundImage: 'url(/assets/images/image 1.png)' }}
      >
        <h3 className="fs-1 fw-bold">
          Get everyone you need to make <br className="brLine" />
          <span className="text-whatshot fw-bold">your event</span> happen.
        </h3>
        <button className="main-button" onClick={openUserTypeModal}>
          Join the Waitlist
        </button>
      </div>
    </Container>
  );
};

export default CTASection;
